import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { UserService } from '../services/user.service';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
@Component({
    selector: 'app-getintouch',
    templateUrl: './getintouch.component.html',
    styleUrls: ['./getintouch.component.css']
})
export class GetinTouchReportComponent implements OnInit {
    displayedColumns = ['business_name', 'customer_name', 'referal_code', 'email', 'contact_number', 'telegram_id', 'trading_vol_monthly', 'message', 'createdAt'];
    public dataSource: any = new MatTableDataSource();
    pageSize = 20;
    pageSizeOptions: number[] = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
    ) { }

    ngOnInit() {
        this.getinTouchList();
    }
    getinTouchList() {
        this.userService.getinTouch().subscribe(data => {
            const getinTouchRes = data.map(d => {
                d.createdAt = moment(d.createdAt).format('MM/DD/YY h:mm:ss A');
                return d;
            })
            this.dataSource = new MatTableDataSource(getinTouchRes);
            this.dataSource.paginator = this.paginator
            this.dataSource.sort = this.sort
        })
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }
    exportGetinTouchData() {
        if (this.dataSource.filteredData) {
            const getinTouchArr = this.dataSource.filteredData.map(x => ({
                BusinessName: x.business_name,
                CustomerName: x.customer_name,
                ReferalCode: x.referal_code,
                Email: x.email,
                ContactNumber: x.contact_number,
                TelegramId: x.telegram_id,
                TradingVolume: x.trading_vol_monthly,
                Message: x.message,
                CreatedAt: x.createdAt,
            }));
            TableUtil.exportArrayToExcel(getinTouchArr, "getinTouchArr");
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/getintouch/getintouch.component.ts